import { createContext, useContext, type ReactNode } from "react";
import type { KeyValueStorage } from "./KeyValueStorage";

interface CacheStorageContextType {
	storage: KeyValueStorage;
}

const CacheStorageContext = createContext<CacheStorageContextType | null>(null);

interface CacheStorageProviderProps {
	storage: KeyValueStorage;
	children: ReactNode;
}

export const CacheStorageProvider = ({
	storage,
	children,
}: CacheStorageProviderProps) => {
	return (
		<CacheStorageContext.Provider value={{ storage }}>
			{children}
		</CacheStorageContext.Provider>
	);
};

export const useCacheStorage = (): KeyValueStorage => {
	const context = useContext(CacheStorageContext);

	if (!context) {
		throw new Error(
			"useCacheStorage must be used within a CacheStorageProvider",
		);
	}

	return context.storage;
};
